import script from "./wxCodeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./wxCodeModal.vue?vue&type=script&setup=true&lang=js"

import "./wxCodeModal.vue?vue&type=style&index=0&id=0fd96b9a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd96b9a"]])

export default __exports__